
import Mirror from "../../../assets/outline/Mirror.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MirrorIcon({ className, dataTestid = "MirrorIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Mirror data-testid={dataTestid} className={classes} {...rest} />
  );
}
